import { type ComponentProps, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import LoadingIcon from '@/components/icons/LoadingIcon';
import Portal from '@/components/Portal';
import { cn } from '@/ui-kit/utils';

type Props = Omit<ComponentProps<'div'>, 'children'> & {
  fullscreen?: boolean;
  text?: string;
};

const Loader = ({ text, fullscreen = false, className, ...props }: Props) => {
  const { t } = useTranslation('Common');
  const Wrapper = fullscreen ? Portal : Fragment;

  return (
    <Wrapper>
      <div
        role="status"
        aria-label={text ?? t('loading')}
        className={cn(
          'bg-surface-default inset-0 flex flex-col items-center justify-center gap-12 px-(--layout-horizontal-padding) lg:gap-20',
          fullscreen ? 'fixed z-(--z-index-full-screen-loader)' : 'absolute',
          className,
        )}
        data-testid="loader-wrapper"
        {...props}
      >
        <LoadingIcon className="text-icon-brand size-22 animate-spin" />

        {!!text && <p className="max-w-110 text-center">{text}</p>}
      </div>
    </Wrapper>
  );
};

export default Loader;
